var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunrise = function SvgSunrise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.71 13.14a3.92 3.92 0 1 1 4.26 0M8.84 2v1.57M1 9.84h1.57M15.12 9.84h1.57M2.96 3.96l1.18 1.18M13.55 5.14l1.18-1.18M1 13.14h16",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgSunrise;